import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paymentSummary: {
    '& .pricingSummaryRows': {
      display: 'flex',
      flexDirection: 'column',
      '& .discounts-info': {
        color: theme.palette.green1,
      },
    },
    padding: '70px 110px 80px',
    [theme.breakpoints.up('md')]: {
      width: '700px',
    },
    [theme.breakpoints.up('lg')]: {
      width: '850px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '60px 20px 30px',
    },
    '& .paymentSummaryInfo': {
      display: 'flex',
      flexFlow: 'row wrap',
      width: '100%',
      padding: '10px 20px',
      '&.discounts-heading': {
        backgroundColor: theme.palette.background.default,
        display: 'flex',
        flexFlow: 'row wrap',
        width: '100%',
      },
      '&.nested-items': {
        width: '96%',
        alignSelf: 'end',
      },
    },
    '& .totalSavings': {
      color: theme.palette.green1,
    },

    '& .paymentSummaryWrapper': {
      '& h1, h3': {
        color: theme.palette.blue1,
        fontFamily: 'ProximaSemibold',
        fontSize: theme.typography.pxToRem(36),
        lineHeight: '150%',
        marginBottom: 30,
      },

      '& h1': {
        [theme.breakpoints.down('lg')]: {
          fontSize: theme.typography.pxToRem(30),
          marginBottom: 20,
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: theme.typography.pxToRem(24),
          marginBottom: 20,
        },
      },

      '& h3': {
        fontSize: theme.typography.pxToRem(24),
        marginBottom: 20,

        [theme.breakpoints.down('sm')]: {
          fontSize: theme.typography.pxToRem(18),
        },
      },

      '& span': {
        display: 'inline-block',
        padding: '0',
        lineHeight: theme.typography.pxToRem('11'),
        textTransform: 'capitalize',
        '&::after': {
          content: "', '",
          paddingRight: '8px',
        },
        '&:last-of-type': {
          paddingLeft: 0,
          '&::after': {
            display: 'none',
          },
        },

        [theme.breakpoints.only('xs')]: {
          '&.deck, &.guarantee': {
            paddingLeft: '0',
            '&::before': {
              display: 'none',
            },
          },
        },
      },

      '& span, & p': {
        color: theme.palette.grey1,
        fontFamily: theme.typography.proxima.regular,
        fontSize: theme.typography.pxToRem('16'),
      },

      '& .price': {
        color: theme.palette.grey1,
        fontSize: theme.typography.pxToRem('16'),
        lineHeight: theme.typography.pxToRem('24'),
      },

      '& .info': {
        flex: 1,
        lineHeight: theme.typography.pxToRem('24'),
        paddingRight: '20px',

        '& span': {
          lineHeight: theme.typography.pxToRem('24'),
        },
      },

      '& p.roomTotal': {
        color: theme.palette.blue1,
        fontFamily: 'ProximaBold',
      },
      [theme.breakpoints.up('sm')]: {
        '& .mobileBreak': {
          display: 'none',
        },
      },
    },
  },
  totalPrice: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,

    '& p': {
      color: theme.palette.blue1,
      fontSize: theme.typography.pxToRem(18),
      fontFamily: 'ProximaSemibold',
      lineHeight: '150%',
    },
  },
}));

export default useStyles;
